export const cloneDeep = require('lodash/cloneDeep') as <T>(value: T) => T;
